// src/components/LandJob.js
import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { getCookie } from "../../utils/index"; // Ensure correct import
import LoginPromptModal from "@/components/homes/heros/LoginPromptModal.js";
import { useRouter } from "next/router";
export default function LandJob() {
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const router = useRouter();
  const [loginModalProps, setLoginModalProps] = useState(null);

  useEffect(() => {
    // Get authToken to check if the user is logged in
    const authToken = getCookie("authToken");
    setIsLoggedIn(!!authToken);

    // Initialize AOS for animations
    AOS.init({ duration: 1000, easing: "ease", once: false });
    AOS.refresh();
  }, []);

  const handleDownloadClick = () => {
    if (isLoggedIn) {
      // Add download logic here
      router.push(
        "https://portal.neetsupport.com/dashboard?scrollTo=ebooks&autoOpen=true"
      );
    } else {
      setShowLoginPrompt(true); // Show login prompt if not logged in
    }
  };

  return (
    <section className="landjob-container" data-aos="zoom-in">
      {/* Left Image Section */}
      <div className="landjob-image ml-[62px] sm:ml-[40px]">
        <img
          src="/assets/images/Dreamjob/Bookwithpage.webp"
          alt="NEET Counselling Guide"
          width="600"
          height="400"
          loading="lazy"
          className="landjob-img"
        />
      </div>

      {/* Right Content Section */}
      <div className="landjob-content download--container">
        <div className="landjob-text-wrapper">
          <h3 className="landjob-heading mt-20 ">
            In-Depth Insights, just a click away!
          </h3>
          <span className="landjob-text">
            Obtain the definitive guide to the NEET Counseling Process.
          </span>
        </div>
        <button
          className="landjob-button"
          style={{ fontSize: "15px" }}
          aria-label="Download NEET Counselling Guide"
          onClick={handleDownloadClick} // Checks login status before showing prompt
        >
          Download
        </button>
      </div>

      {/* Login Prompt Modal */}
      {showLoginPrompt && (
        <LoginPromptModal onClose={() => setShowLoginPrompt(false)} />
      )}
    </section>
  );
}
